export default "__VITE_ASSET__yfpJ$fDC__"